export enum ROLES {
    SUPER_ADMIN = 'SUPER_ADMIN',
    HOST = 'HOST',
    AMBASSADOR = 'AMBASSADOR',
    ATTENDEE = 'ATTENDEE',
    CHILD = 'CHILD',
    RSVP = 'RSVP',
    User = 'user',
    Admin = 'admin',
  }

  export enum LEADER_ROLES{
    HOST = 'HOST',
    AMBASSADOR = 'AMBASSADOR',
    ATTENDEE = 'ATTENDEE',
  }